import { StyleSheet } from 'aphrodite';
import { SPACE, THEME } from '../../../../web/components-v2/Theme/theme';

const { colors, common, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		background: colors.background.light,
		border: `1px solid ${colors.border.light}`,
		borderRadius: common.borderRadius,
		boxSizing: 'border-box',
		color: colors.text.main,
		display: 'flex',
		flexDirection: 'column',
		fontSize: typography.fontSizes.sm,
		gap: SPACE[16],
		padding: `${SPACE[16]}px ${SPACE[56]}px ${SPACE[16]}px ${SPACE[16]}px`,
		position: 'relative',
	},
	deleteContainer: {
		position: 'absolute',
		right: SPACE[8],
		top: SPACE[8],
	},
	fileContainer: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[32],
	},
	input: {
		flex: 1,
		minWidth: 0,
	},
	loader: {
		height: SPACE[64],
	},
	textContainer: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[8],
	},
	textLabel: {
		fontWeight: typography.fontWeights.semibold,
		marginRight: SPACE[4],
	},
});
